import Send from "@mui/icons-material/Send";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { ScheduleButton, type ScheduleButtonProps } from "./schedule-button";

export const ScheduleImmediateButton: FC<Omit<ScheduleButtonProps, "icon" | "title">> = (props) => {
  const { t } = useTranslation();

  return <ScheduleButton icon={<Send />} title={t("Send immediately")} {...props} />;
};
